import React, { useContext, useEffect, useState } from 'react';
import { Button, Modal, Header } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import { FundingInfo } from '../../app/models/Investment/FundingInfo';
import EntityContext from '../../app/context/entityContext';
import { toast } from 'react-toastify';
import CheckTransferInfo from './CheckTransferInfo';
import WireTransferInfo from './WireTransferInfo';
import { InvestmentInterest } from '../../app/models/Investment/InvestmentInterest';
import { InvestmentFundingMethod } from '../../app/models/Investment/InvestmentInterestGrid';

interface Props {
    show: boolean;
    closeModal: (refreshData: boolean) => void;
    interest: InvestmentInterest;
    investmentId: number;
}

function FundingTransferInfo({ show, closeModal, interest, investmentId }: Props) {
    const { investmentStore } = useStore();
    const [funding, setFunding] = useState(new FundingInfo());
    const { entity } = useContext(EntityContext);
    const title = interest.fundingMethod === InvestmentFundingMethod.wireTransfer ? 'Wire' : 'Check';
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        investmentStore.getFundingInfo(investmentId)
            .then(r => {
                setFunding(r);
            })
            .finally(() => setLoading(false));
    }, [investmentStore, investmentId]);

    const confirmPayment = () => {
        investmentStore.updateInvestmentInterestStatus(entity.id, interest.id)
            .then(r => {
                toast.success("Funding info updated successfully.", { theme: "colored" });
                closeModal(true);
            })
            .catch(err => {
                toast.error("There was an issue updating the funding.", { theme: "colored" });
            })
    }
    return (
        <Modal size="small" centered={false} open={show} closeOnEscape={false} closeOnDimmerClick={false}>
            <Modal.Header>
                <Header color='blue'>{title} Transfer Information</Header>
            </Modal.Header>
            <Modal.Content>
                {!loading &&
                    <>
                        {interest.fundingMethod === InvestmentFundingMethod.wireTransfer ?
                            <WireTransferInfo interestId={interest.id} fundingInfo={funding} /> :
                            <CheckTransferInfo interestId={interest.id} fundingInfo={funding} />
                        }
                    </>
                }
            </Modal.Content>
            <Modal.Actions style={{ display: 'flex', justifyContent: 'center' }}>
                <Button primary content={`${title} Completed`} onClick={confirmPayment} />
                <Button content="Cancel" onClick={() => closeModal(false)} />
            </Modal.Actions>
        </Modal>
    );
}

export default FundingTransferInfo;
